import React from 'react';
import { Col, Container, FlexibleCol, GridWrapper } from '@yme/atoms/grid';
import { Image } from '@yme/atoms/image';
import { IndentWrapper } from '@yme/components/Separator';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { ButtonLinkWrapper } from '@yme/molecules/buttons';
import { PromoCard } from '@yme/molecules/cards';
import { AspectRatio } from '@yme/utils/constants';
import { CardColDesktopStyled, CardRowStyled, PromoCardContainerStyled, PromoDesktopRowStyled, } from './styled';
export function PromoSection(props) {
    const { image, title, buttonLabel, buttonLink, subtitle, description, isRemoveBottomIndent, isRightToLeft, } = props;
    const { isTabletView, isMobileView, isInfiniteDesktopView } = useWindowSize();
    const promoCardFragment = (React.createElement(PromoCard, { buttonLabel: buttonLabel, image: image, title: title, subtitle: subtitle, description: description, buttonLink: buttonLink }));
    // markup for large screens (desktop and above)
    const desktopView = (React.createElement(Container, null,
        React.createElement(PromoDesktopRowStyled, null,
            React.createElement(CardColDesktopStyled, { lg: 4, isRightToLeft: isRightToLeft }, promoCardFragment),
            React.createElement(FlexibleCol, { lg: 11 },
                React.createElement(ButtonLinkWrapper, { buttonLink: buttonLink },
                    React.createElement(Image, { ...image, aspectRatio: AspectRatio.RectangleLevel3, objectFit: "contain", alt: title }))))));
    // layout for middle screens from tablet to desktop
    const tabletView = (React.createElement(React.Fragment, null,
        React.createElement(GridWrapper, null,
            React.createElement(ButtonLinkWrapper, { buttonLink: buttonLink },
                React.createElement(Image, { ...image, aspectRatio: AspectRatio.RectangleLevel3, objectFit: "contain", alt: title }))),
        React.createElement(PromoCardContainerStyled, null,
            React.createElement(CardRowStyled, null,
                React.createElement(Col, { md: 6, sm: 4 }, promoCardFragment)))));
    // layout for small screens from mobile to tablet
    const mobileView = (React.createElement(React.Fragment, null,
        React.createElement(ButtonLinkWrapper, { buttonLink: buttonLink },
            React.createElement(Image, { ...image, aspectRatio: AspectRatio.RectangleLevel3, objectFit: "contain", alt: title })),
        React.createElement(PromoCardContainerStyled, null,
            React.createElement(CardRowStyled, null,
                React.createElement(Col, { md: 6, sm: 4 }, promoCardFragment)))));
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent, isRightToLeft: isRightToLeft, dataTestId: "PromoSection" },
        isInfiniteDesktopView && desktopView,
        isTabletView && tabletView,
        isMobileView && mobileView));
}
PromoSection.displayName = 'PromoSection_Organism';
